import React, { createContext, useContext, useReducer, useMemo } from 'react';
import { contextReducer, CupBookingActions } from './CupBookingReducer';
import { PrestazioneDTO } from 'model/Prestazione';

export interface CupBookingContextValue {
  prestazione:
    | null
    // | ({
    //     type: 'PrestazioneDetailParsed';
    //   } & PrestazioneDetailParsed)
    // | ({
    //     type: 'PrestazioneItemShort';
    //   } & PrestazioneItemShort);
    | ({
        type: 'PrestazioneDTO';
      } & PrestazioneDTO);
}
export interface CupBookingContextActionsProps {
  dispatch: React.Dispatch<CupBookingActions>
}

const ContextState: CupBookingContextValue = {
  prestazione: null,
};

const CupBookingContext = createContext<CupBookingContextValue>(ContextState);
const CupBookingContextActions = createContext<CupBookingContextActionsProps>({
  dispatch: () => {},
});

const useCupBookingContext = (): CupBookingContextValue =>
  useContext(CupBookingContext);
const useCupBookingContextActions = (): CupBookingContextActionsProps =>
  useContext(CupBookingContextActions);

const CupBookingContextProvider: React.FC = ({children}) => {
  const [state, dispatch] = useReducer(
    contextReducer,
    ContextState,
    () => ContextState,
  );

  const actionsValue = useMemo(() => ({dispatch}), [dispatch]);

  return (
    <CupBookingContext.Provider value={state}>
      <CupBookingContextActions.Provider value={actionsValue}>
        {children}
      </CupBookingContextActions.Provider>
    </CupBookingContext.Provider>
  );
};

export {CupBookingContextProvider, useCupBookingContext, useCupBookingContextActions};
